export default {
  copySuccess: 'La valeur a été copiée dans le presse-papiers',
  copyError: 'La valeur n\'a pas été copiée dans le presse-papiers. Quelque chose s\'est mal passé...',
};
